import React from 'react'
import theme from '../../../styles/theme'

interface Props {
    isActiveStep: boolean
}

const Dot: ({ isActiveStep }: Props) => JSX.Element = ({ isActiveStep }: Props) => {
    {
        return (
            <div
                style={{
                    borderRadius: '50%',
                    height: '10px',
                    width: '10px',
                    backgroundColor: isActiveStep ? theme.colors.secondaryColor : theme.colors.gray200,
                }}
            />
        )
    }
}
export default Dot
